module.exports = __webpack_public_path__ + "static/media/time-art.09531870.png";